// import {
//     ApplySettingField,
//     InnerSettingCell, SelectSettingCell,
//     SettingCell,
//     SettingInput, SettingSelect, SettingSelectListContainer, SettingSelectListItem,
//     SettingsInfo
// } from "../ToFlowMain/TOFlow.styled";
import {
    setFeeFilter,
    setFilterPercent,
    setHiddenExchanges,
    setHideNumFilter,
    setHighlightFrom
} from "../../redux/actions";
import React, {useState} from "react";
import {getState, useAppDispatch} from "../../redux/store";
import {ReactComponent as ArrowDownNew} from "../../assets/icons/arrow_down.svg"
import {ReactComponent as ArrowUp} from "../../assets/icons/arrow_up.svg"
import {ReactComponent as ExchangeDot} from "../../assets/icons/ex_dot.svg"
import {
    ApplySettingCell,
    ApplySettingField, IncrementalContainer,
    InnerSettingCell, SelectSettingCell,
    SettingCell, SettingCellHeader, SettingIncremental,
    SettingInput, SettingSelect,
    SettingSelectListContainer, SettingSelectListItem,
    SettingsInfo,
} from "./Settings.styled";
import {useSelector} from "react-redux";
import {selectors} from "../../redux/selectors";
import {AppText} from "../../utils";
// import {SelectSettingCell, SettingCell, SettingSelect} from "../ToFlowMain/TOFlow.styled";

// const SETTING_KEY = 'SettingsKey'
const HIDE_EX_KEY = 'HiddenExchangesKey'

// interface ISetting {
//     highlightFrom?: string,
//     substructFeeFrom?: string,
//     hideLowerThan?: string,
//     percentFilter?: string,
// }

export const TOFSettings: React.FC<{isMobile: boolean}> = ({isMobile}) => {
    const dispatch = useAppDispatch()
    const [hiddenEx, setHiddenEx] = useState<string[]>(JSON.parse(localStorage.getItem(HIDE_EX_KEY) || JSON.stringify([])))
    const [isHideExOpen, setIsHideExOpen] = useState<boolean>(false)
    const [highlightFromLocal, setHighlightFromLocal] = useState<string | undefined>(JSON.parse(localStorage.getItem('highlightFrom') ?? '0'))
    const [substructFeeFrom, setSubstructFeeFrom] = useState<string | undefined>(JSON.parse(localStorage.getItem('substructFeeFrom') ?? '0'))
    const [hideLowerThan, setHideLowerThan] = useState<string | undefined>(JSON.parse(localStorage.getItem('hideLowerThan') ?? '0'))
    const [filterPercentLocal, setFilterPercentLocal] = useState<string | undefined>(JSON.parse(localStorage.getItem('filterPercent') ?? '0'))
    const lang = useSelector(selectors.selectLang)
    const mockExchanges = [
        'Binance', 'Bitget', 'ByBit', 'GateIo', 'MEXC', 'Kucoin', 'Huobi', 'Poloniex', 'Pancake'
    ]

    const handleHiddenEx = (listItem: string): void => {
        const prev_hidden_ex_vec = [...hiddenEx]
        let vec_to_set = []
        vec_to_set = hiddenEx.includes(listItem) ?
            [...prev_hidden_ex_vec].filter(ex => ex !== listItem)
            : [...prev_hidden_ex_vec, listItem]

        localStorage.setItem(
            HIDE_EX_KEY,
            JSON.stringify(vec_to_set)
        )
        dispatch(setHiddenExchanges(vec_to_set))
        setHiddenEx(vec_to_set)
    }

    const clickUpIncrement = (callback: React.Dispatch<React.SetStateAction<string | undefined>>) => {
        callback((prev) => {
            if (prev) {
              return (Number(prev) + 0.1).toFixed(2)
            } else {
               return  '0.1'
            }
        })
    }
    const clickUpDecrement = (callback: React.Dispatch<React.SetStateAction<string | undefined>>) => {
        callback((prev) => {
            if (prev) {
                const newVal = Number(prev) - 0.1
                if (newVal < 0) {
                    return '0'
                } else {
                    return (Number(prev) - 0.1).toFixed(2)
                }
            } else {
                return  '0'
            }
        })
    }

    return (
        <SettingsInfo isMobile={isMobile}>
            <SettingCell isTop>
                <SettingCellHeader>{AppText[lang].settings.a} ($)</SettingCellHeader>
                <InnerSettingCell>
                    <SettingInput
                        value={highlightFromLocal}
                        placeholder={highlightFromLocal}
                        onChange={e => {
                            setHighlightFromLocal(e.target.value)
                        }}
                    />
                    <IncrementalContainer>
                        <SettingIncremental isTop onClick={() => clickUpIncrement(setHighlightFromLocal)}>
                            <ArrowUp/>
                        </SettingIncremental>
                        <SettingIncremental onClick={() => clickUpDecrement(setHighlightFromLocal)}>
                            <ArrowDownNew/>
                        </SettingIncremental>
                    </IncrementalContainer>
                </InnerSettingCell>
            </SettingCell>

            <SettingCell>
                <SettingCellHeader>{AppText[lang].settings.b} (%)</SettingCellHeader>
                <InnerSettingCell>
                    <SettingInput
                        value={substructFeeFrom}
                        placeholder={substructFeeFrom}
                        onChange={e => {
                            setSubstructFeeFrom(e.target.value)
                        }}
                    />
                    <IncrementalContainer>
                        <SettingIncremental isTop onClick={() => clickUpIncrement(setSubstructFeeFrom)}>
                            <ArrowUp/>
                        </SettingIncremental>
                        <SettingIncremental onClick={() => clickUpDecrement(setSubstructFeeFrom)}>
                            <ArrowDownNew/>
                        </SettingIncremental>
                    </IncrementalContainer>
                </InnerSettingCell>
            </SettingCell>

            <SettingCell>
                <SettingCellHeader>{AppText[lang].settings.c} ($)</SettingCellHeader>
                <InnerSettingCell>
                    <SettingInput
                        value={hideLowerThan}
                        placeholder={hideLowerThan}
                        onChange={e => {
                            setHideLowerThan(e.target.value)
                        }}
                    />
                    <IncrementalContainer>
                        <SettingIncremental isTop onClick={() => clickUpIncrement(setHideLowerThan)}>
                            <ArrowUp/>
                        </SettingIncremental>
                        <SettingIncremental onClick={() => clickUpDecrement(setHideLowerThan)}>
                            <ArrowDownNew/>
                        </SettingIncremental>
                    </IncrementalContainer>
                </InnerSettingCell>
            </SettingCell>
            <SettingCell>
                <SettingCellHeader>{AppText[lang].settings.d} (%)</SettingCellHeader>
                <InnerSettingCell>
                    <SettingInput
                        value={filterPercentLocal}
                        placeholder={filterPercentLocal}
                        onChange={e => {
                            setFilterPercentLocal(e.target.value)
                        }}
                    />
                    <IncrementalContainer>
                        <SettingIncremental isTop onClick={() => clickUpIncrement(setFilterPercentLocal)}>
                            <ArrowUp/>
                        </SettingIncremental>
                        <SettingIncremental onClick={() => clickUpDecrement(setFilterPercentLocal)}>
                            <ArrowDownNew/>
                        </SettingIncremental>
                    </IncrementalContainer>
                </InnerSettingCell>
            </SettingCell>
            <SelectSettingCell>
                <SettingCellHeader>{AppText[lang].settings.e}</SettingCellHeader>
                <SettingSelect onClick={() => setIsHideExOpen((prev) => !prev)} isActive={isHideExOpen}>
                    {hiddenEx.length === 0 ? 'NO HIDDEN EXCHANGES' : 'ALL'} {isHideExOpen ? (<ArrowUp/>) :(<ArrowDownNew/>)}
                    {isHideExOpen ? (
                        <SettingSelectListContainer>
                            {mockExchanges.map(listItem => {
                                return (
                                    <SettingSelectListItem
                                        onClick={(e) => {
                                            handleHiddenEx(listItem)
                                            e.stopPropagation()
                                        }}
                                        isIncluded={hiddenEx.includes(listItem)}
                                    >
                                        <div>
                                            {listItem.toUpperCase()}
                                        </div>
                                        <div>
                                            <ExchangeDot/>
                                        </div>
                                    </SettingSelectListItem>
                                )
                            })}
                        </SettingSelectListContainer>
                    ) : (<></>)}
                </SettingSelect>
            </SelectSettingCell>
            <ApplySettingCell>
                {!isHideExOpen && (<ApplySettingField onClick={(() => {
                    localStorage.setItem('highlightFrom', JSON.stringify(highlightFromLocal))
                    localStorage.setItem('hideLowerThan', JSON.stringify(hideLowerThan))
                    localStorage.setItem('substructFeeFrom', JSON.stringify(substructFeeFrom))
                    localStorage.setItem('filterPercent', JSON.stringify(filterPercentLocal))
                    localStorage.setItem('HiddenExchangesKey', JSON.stringify(hiddenEx))

                    dispatch(setHighlightFrom(highlightFromLocal ? Number(highlightFromLocal) : undefined))
                    dispatch(setHideNumFilter(hideLowerThan ? Number(hideLowerThan) : undefined))
                    dispatch(setFeeFilter(substructFeeFrom ? Number(substructFeeFrom) : undefined))
                    dispatch(setFilterPercent(filterPercentLocal ? Number(filterPercentLocal) : undefined))
                    dispatch(setHiddenExchanges(hiddenEx))
                })}>{AppText[lang].settings.f}</ApplySettingField>)}
            </ApplySettingCell>
        </SettingsInfo>
    )
}